import React, { Component } from "react";
import { directoryService } from '../services/directory';

import '../assets/styles/Directory.scss';
import _ from 'lodash';

import Spinner from 'react-bootstrap/Spinner';
import SEO from './SEO';

class Locations extends Component {

    constructor(props){
        super(props);

        this.state = {
            loading: false,
            directories: [],
            filtered_directories: [],
            filters: global.constant.directory_filters,
            metadata: {
                title: 'Find Healthcare Professionals By Location',
                description: 'Find healthcare professionals available by location at BookDoc. View available time slots and book appointments instantly!',
                type: 'website'
            }
        }
    }

    getLocations(){
        this.setState({
            loading: true
        });

        directoryService.locations()
        .then(
            data => {
                if(data){
                    data = data.map(country => {
                        if(country.name === 'Singapore'){
                            return  {...country, ...{
                                states: [country]
                            }}
                        }
                        return country;
                    })

                    this.setState({
                        directories: data,
                        filtered_directories: data
                    });
                }
            },
            error => {
                console.log(error)
                this.setState({ error })
            }
        ).then(() => {
            this.setState({
                loading: false
            });
        });
    }

    componentDidMount(){
        this.getLocations();
    }

    filterBy(value){
        if(value === 'All'){
            this.setState({
                filtered_directories: this.state.directories
            });
        }else{
            this.setState({
                filtered_directories: _.filter(this.state.directories, function(o) {
                    let states =  _.filter(o.states, function(x) {
                        return _.startsWith(_.upperCase(x.name), value);
                    });
                    return states.length > 0;
                }).map(country => {
                    return {...country, ...{
                        states: _.filter(country.states, function(x) {
                            return _.startsWith(_.upperCase(x.name), value);
                        })
                    }}
                })
            });
        }
    }

    render() {
        return (
            <>
            <SEO 
            title={this.state.metadata.title} 
            description={this.state.metadata.description}
            type={this.state.metadata.type} />
            <div className="directory-page container">
                <div className="header">
                    <h1 className="title">Find By Location</h1>
                </div>
                <hr className="header-line"/>
                <div className="body">
                    {(() => {
                        if (this.state.loading) {
                            return <div className="loader"><Spinner animation="border" className="spinner"/></div>;
                        } else {
                            return (
                                <div className="directory-content">
                                    <div className="filters d-flex justify-content-center flex-wrap">
                                        {
                                            this.state.filters.map((filter, index) => (
                                                <button type="button" className="filter-option btn btn-link" key={`filter-${index}`} onClick={() => this.filterBy(filter)}>
                                                    {filter}
                                                </button>
                                            ))
                                        }
                                    </div>
                                        {_.isEmpty(this.state.filtered_directories) ? (
                                            <div className="empty-div">No Location</div>
                                        ) : (
                                            <div className="directory-items">
                                                {
                                                    this.state.filtered_directories.map((country, index) => (
                                                        <div className="country" key={`country-${index}`}>
                                                            <div className="country-name">{country.name}</div>
                                                            <hr />
                                                            <div className="states">
                                                                {
                                                                    country.states.map((state, sub_index) => {
                                                                        if(state.name === 'Singapore'){
                                                                            return <a href={`/../search-book/result?location=${country.name}&country_id=${country.id}&location_type=available_country&specialty=General%20Practitioner%20(GP%20Doctor)&type=specialty`} className="item btn btn-link" key={`directory-item-${sub_index}`}>
                                                                            {state.name}</a>
                                                                        }else{
                                                                            return <a href={`/../search-book/result?location=${country.name}&state=${state.name}&state_id=${state.id}&location_type=available_country&specialty=General%20Practitioner%20(GP%20Doctor)&type=specialty`} className="item btn btn-link" key={`directory-item-${sub_index}`}>
                                                                            {state.name}</a>
                                                                        }
                                                                    })
                                                                }
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        )}
                                </div>
                            );
                        }
                    })()}
                </div>
            </div>
            </>
        );
    }
}

export { Locations };
